export default __webpack_public_path__ + "static/108089-a0d434bb229ea2c90636f8acb67bc53a.jpg";